import { useState } from 'react';
import { useContactSubmissions } from '../../../api/admin';
import { Pagination } from '../shared/Pagination';
import { EmptyState } from '../shared/EmptyState';

export function ContactSubmissionsList() {
  const [page, setPage] = useState(1);
  const { data, isLoading } = useContactSubmissions(page);
  const [expandedId, setExpandedId] = useState<number | null>(null);

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-8 w-8 border-2 border-spi-green border-t-transparent" />
      </div>
    );
  }

  if (!data?.data.length) {
    return <EmptyState title="No contact submissions" description="Contact form submissions will appear here." />;
  }

  return (
    <div>
      <p className="text-sm text-spi-slate mb-4">{data.total} submission{data.total !== 1 ? 's' : ''} total</p>
      <div className="space-y-3">
        {data.data.map((sub) => (
          <div key={sub.id} className="bg-white rounded-xl border border-spi-parchment p-4">
            <div className="flex items-start justify-between gap-4">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 mb-1">
                  <span className="font-semibold text-spi-charcoal">{sub.name}</span>
                  {sub.organization && (
                    <span className="text-xs text-spi-slate bg-spi-seed px-2 py-0.5 rounded-full">{sub.organization}</span>
                  )}
                </div>
                <a href={`mailto:${sub.email}`} className="text-sm text-spi-green hover:underline">{sub.email}</a>
              </div>
              <div className="text-xs text-spi-slate whitespace-nowrap">
                {new Date(sub.created_at + 'Z').toLocaleDateString(undefined, {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit',
                })}
              </div>
            </div>
            <div className="mt-3">
              <p className={`text-sm text-spi-charcoal whitespace-pre-wrap ${
                expandedId === sub.id ? '' : 'line-clamp-2'
              }`}>
                {sub.message}
              </p>
              {sub.message.length > 150 && (
                <button
                  onClick={() => setExpandedId(expandedId === sub.id ? null : sub.id)}
                  className="text-xs text-spi-green hover:underline mt-1"
                >
                  {expandedId === sub.id ? 'Show less' : 'Show more'}
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      <Pagination page={data.page} totalPages={data.totalPages} onPageChange={setPage} />
    </div>
  );
}
